module.exports = __webpack_public_path__ + "static/media/unlock.d728ab94.svg";